import "./AddIpModal.scss";
import { useSelector } from "react-redux";
import { IconSvg } from "../../../../../../../../../utils/constants/icons/iconSvg.constant";
import { Button } from "../../../../../../../../../components/ui/Buttons/Button/Button";
import { useSetZIndex } from "../../../../../../../../../hooks/useSetZIndex";
import { CustomModal } from "../../../../../../../../../components/ui/CustomModal/CustomModal";
import { useTranslation } from "../../../../../../../../../hooks";

export const RemoveIpModal = ({ onClose }) => {
  useSetZIndex(".cabinet", "999");

  const { skin } = useSelector((state) => state.header);

  const { cabinet: { orders: { residential: {
    removeWhiteListIpModalTitle, cancel, remove
  } } } } = useTranslation();

  return (
    <CustomModal
      open={true}
      styles={{ zIndex: "999999999" }}
      onClose={onClose}
    >
      <div className="add-ip-modal">
        <div className="add-ip-modal__icon">
          <IconSvg tag={`addIpModal_${skin}`} />
        </div>
        <div className="add-ip-modal__title">{removeWhiteListIpModalTitle}</div>
        <div className="add-ip-modal__actions">
          <Button>{cancel}</Button>
          <Button tab="confirm">{remove}</Button>
        </div>
      </div>
    </CustomModal>
  );
};
